import { goodsSkuPage,brandList } from "@/api/goods/goods"
import { mapGetters } from "vuex"
import { relevanceinfo, goodsCategoryInfo,tree } from "@/api/goods/goodscategory"
import { addCollect, deleteCollect, isCollect } from "@/api/goods/goods_collect"
import { getArea,getCity } from "@/api/address"
import { usedList, usedDetail} from "@/api/cms/used"

export default {
    data: () => {
        return {
            cargoList: [],
            shopList: [], // 店铺列表
            brandList: [], // 品牌列表
            // attributeList: [], // 属性列表
            // brandInitialList: [],
            // currentInitial: "", // 当前选择品牌分区
            // choosedBrand: "", // 已选择的品牌,
            // hasChoosedAttrs: false, // 忆选择的属性
            total: 0,
            keyword: "",
            catewords:'',
            currentPage: 1,
            pageSize: 12,
            is_free_shipping: 0,
            is_own: "",
            filters: {
                site_id: 0,
                category_id: 0,
                category_level: 0,
                brand_id: 0,
                min_price: "",
                max_price: "",
                order: "",
                sort: "desc",
                platform_coupon_type: 0,
				area_id:0,
				province_id:0,
				city_id:0,
				type:2,
            },
            loading: true,
            // whetherCollection: 0,
			categoryList:[],
			priceList:[
				{
					min_price:'',
					max_price:'',
					name:'不限'
				},
				{
					min_price:0,
					max_price:50000,
					name:'5万以内'
				},
				{
					min_price:50000,
					max_price:100000,
					name:'5万-10万'
				},
				{
					min_price:100000,
					max_price:500000,
					name:'10万-50万'
				},
				{
					min_price:500000,
					max_price:1000000,
					name:'50万-100万'
				},
				{
					min_price:1000000,
					max_price:2000000,
					name:'100万-200万'
				},
				{
					min_price:2000000,
					max_price:99999999,
					name:'200万以上'
				},
			],
			// area:{
			// 	province:[],
			// 	city:[]
			// },
        }
    },
    created() {
		// console.log('333created');
  //       this.keyword = this.$route.query.keyword || ""
		
  //       this.filters.category_id = this.$route.query.category_id || 0
  //       this.filters.category_level = this.$route.query.level || 0
  //       this.filters.brand_id = this.$route.query.brand_id || 0
  //       this.filters.platform_coupon_type = this.$route.query.platform_coupon_type || 0
  //       this.load()
    },
	mounted(){
		console.log('mounted');
		this.keyword = this.$route.query.keyword || ""
		
		this.filters.category_id = this.$route.query.category_id || ""
		this.filters.category_level = this.$route.query.level || ""
		this.filters.brand_id = this.$route.query.brand_id || ""
		this.filters.platform_coupon_type = this.$route.query.platform_coupon_type || 0
		
		this.filters.area_id = this.$route.query.area_id || 0
		// this.getAreaList();
		// this.load()
		// console.log(111111,this.area);
	},
    computed: {
        ...mapGetters(["defaultGoodsImage","area"])
    },
    methods: {
		load(){
			this.getGoodsList()
			// if (this.filters.category_id) {
			    // this.getRelevanceinfo()
			    // this.categorySearch()
			// }
			// this.getCategoryList();
			// this.getAreaList();
			// this.getBrandList()
		},
        /**
         * 商品分类搜索
         */
        
        getGoodsList() {
			
            const params = {
                page: this.currentPage,
                page_size: this.pageSize,
                site_id: this.filters.siteId,
                keyword: this.keyword,
                // attr: currentArr.length > 0 ? JSON.stringify(currentArr) : "",
                ...this.filters
            }
            usedList(params || {})
                .then(res => {
                    const { count, page_count, list } = res.data
                    this.total = count
                    this.cargoList = list
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
        },

        handlePageSizeChange(size) {
            this.pageSize = size
            this.getGoodsList()
        },
        handleCurrentPageChange(page) {
            this.currentPage = page
            this.getGoodsList()
        },
        handlePriceRange() {
            this.getGoodsList()
        },
        handleChangeInitial(initial) {
            this.currentInitial = initial
        },
        changeSort(type) {
            if (this.filters.order === type) {
                this.$set(this.filters, "sort", this.filters.sort === "desc" ? "asc" : "desc")
            } else {
                this.$set(this.filters, "order", type)
                this.$set(this.filters, "sort", "desc")
            }
            this.getGoodsList()
        },
		getBrandList(){
			brandList({
				// pid:1
				page_size:30
			})
			.then(res => {
				if (res.code == 0 && res.data) {
					
					this.brandList = res.data.list;
				}
			})
			.catch(err => {
				this.$message.error(err.message);
			});
		}
    },
    watch: {
        is_free_shipping: function (val) {
            this.filters.is_free_shipping = val ? 1 : ""
            this.getGoodsList()
        },
        is_own: function (val) {
            this.filters.is_own = val ? 1 : ""
            this.getGoodsList()
        },
        $route: function (curr) {
			// console.log(1111113333,curr.query.category_id);
			this.keyword = curr.query.keyword
			
            if (curr.query.category_id != undefined) {
                this.catewords = ""
                this.currentPage = 1
                this.filters.category_id = curr.query.category_id || ""
                this.filters.category_level = curr.query.level || ""
                this.filters.brand_id = curr.query.brand_id || ""
            }
        },
		keyword:function (val) {
			console.log(666);
			this.load()
        },
		filters:{
			handler(newName, oldName) {
				console.log('filters changed333',newName,oldName);
				this.load()
			},
			immediate: true,
			deep:true
		}
    }
}
